module.exports = __webpack_public_path__ + "img/title_about.e95f7652.png";